var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtillery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12.4 4.8 46.8 46.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 4 Q56 18 56 32 Q56 46 37 60",
    fill: "none",
    stroke: "#5a3a1c",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 4 Q56 18 56 32 Q56 46 37 60",
    fill: "none",
    stroke: "#b0804a",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 4 L13 32 L37 60",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32 L60 32",
    stroke: "#3a2a1a",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32 L58 32",
    stroke: "#d9c7a0",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 32 L57 27 L57 37Z",
    fill: "#555",
    stroke: "#333",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b3261e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 31 L22 31 L18 25.5 L11 25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 33 L22 33 L18 38.5 L11 38.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtillery);
export default __webpack_public_path__ + "static/media/artillery.3ac65338d953ff4e84d9aa6a0d971f5b.svg";
export { ForwardRef as ReactComponent };